export default __webpack_public_path__ + "static/media/face-recognition.1d5430ec.png";